const themeContract = {
  tu: {
    borderRadius: '',
    heading: {
      mobileDisplay: 'display-1'
    },
    voucher: {
      verticalPadding: 10,
      borderRadius: ''
    }
  },
  argos: {
    borderRadius: '',
    heading: {
      mobileDisplay: 'display-1'
    },
    voucher: {
      verticalPadding: 10,
      borderRadius: ''
    }
  },
  habitat: {
    borderRadius: 'radius',
    heading: {
      mobileDisplay: 'display-2'
    },
    voucher: {
      verticalPadding: 20,
      borderRadius: 'radius'
    }
  },
  nectar: {
    borderRadius: 'radius',
    heading: {
      mobileDisplay: 'display-2'
    },
    voucher: {
      verticalPadding: 20,
      borderRadius: 'radius'
    }
  },
  sainsburys: {
    borderRadius: 'radius',
    heading: {
      mobileDisplay: 'display-2'
    },
    voucher: {
      verticalPadding: 20,
      borderRadius: 'radius'
    }
  }
}

export { themeContract }
